import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AppConfigService } from '@config/app-config.service';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class AppIdentifierInterceptor implements HttpInterceptor {
  private readonly appConfigService = inject(AppConfigService);

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    const appIndentifier = this.appConfigService.appIdentifier();

    if (appIndentifier && request.url.startsWith(environment.backendUrl)) {
      request = request.clone({
        // eslint-disable-next-line @typescript-eslint/naming-convention
        setHeaders: { 'X-app-identifier': appIndentifier.uuid },
      });
    }

    return next.handle(request);
  }
}
